import { render, staticRenderFns } from "./CompetitiveProcessesCardSkeleton.vue?vue&type=template&id=2110a866"
import script from "./CompetitiveProcessesCardSkeleton.vue?vue&type=script&lang=js"
export * from "./CompetitiveProcessesCardSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports